<script lang="ts" setup>
import type { BlockRootContext, BlockSerialized } from '#layers/block-engine';
import type { GlobalCollectionId } from '#layers/data-model';
import { computed } from 'vue';
import { generatedItemMarker } from '~~/shared/constants/rstore';
import { blockRenderDataFactory } from '#layers/spaces';

const props = defineProps<{
	collectionId: GlobalCollectionId;
	type: NonNullable<BlockRootContext['pageType']>;
	blockContext?: Omit<BlockRootContext, 'collectionId' | 'pageType'>;
}>();

// TODO load custom default block

const block = computed<BlockSerialized>(() => {
	if (props.type === 'listing') {
		return {
			id: `${generatedItemMarker}:default-listing:${props.collectionId}`,
			name: 'Block',
			...blockRenderDataFactory({
				children: {
					listing: {
						blockId: '$builtin:Listing',
					},
				},
				rootChildren: ['listing'],
			}),
		};
	}

	if (props.type === 'detail') {
		return {
			id: `${generatedItemMarker}:default-detail:${props.collectionId}`,
			name: 'Block',
			...blockRenderDataFactory({
				children: {
					form: {
						blockId: '$builtin:Form',
					},
				},
				rootChildren: ['form'],
			}),
		};
	}

	throw new Error(`Unsupported page type: ${props.type}`);
});

const context = computed<BlockRootContext>(() => ({
	collectionId: props.collectionId,
	pageType: props.type,
	...props.blockContext,
}));
</script>

<template>
	<BlockRender
		:block
		:context
		v-bind="$attrs"
	/>
</template>
